import { sectionToCategoryMap } from '../constants/sectionsAndCategories';

export function mapSectionToCategory(section?: string | null): string {
  if (!section) {
    return 'other_page';
  }

  return sectionToCategoryMap[section] || 'other_page';
}
